module.exports = __webpack_public_path__ + "img/pic_suppay_rating@3x.c35eaa83.png";